import moment from 'moment';
import React from 'react';
import DOMPurify from 'dompurify';
import { marked } from 'marked';

function HumanMessage({ user, message }) {
  return (
    <div className="bg-light bg-opacity-75 border px-3 py-2 rounded w-75 ms-auto my-2">
      <div className="d-flex align-items-center justify-content-between">
        <h6 className="m-0 fw-bold h6">{`${user.name} ${user.surname}`}</h6>
        <p className="m-0 text-end mt-2">
          <small>{moment(message.created_at).fromNow()}</small>
        </p>
      </div>
      <hr className="my-1" />
      <p className="m-0" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(marked.parse(message.message)) }} />
    </div>
  );
}

export default HumanMessage;
